// extracted by mini-css-extract-plugin
module.exports = {"container":"Account_container__3gyhT","anim":"Account_anim__1Hh5n","message":"Account_message__3e3Ba","connect":"Account_connect__3NJXv"};